if (!customElements.get('tp26-slider')) {
 customElements.define('tp26-slider', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort(); this.abort = new AbortController();
   const signal = this.abort.signal;
   this.track = this.querySelector('.tp26-track');
   const controls = this.querySelector('.tp26-controls');
   if (!this.track || !controls) return;
   this.cards = [...this.track.children];
   this.prev = controls.querySelector('[data-prev]'); this.next = controls.querySelector('[data-next]');
   this.dots = controls.querySelector('.tp26-dots');
   this.dots.replaceChildren();
   this.cards.forEach((card, i) => {
    const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', `Go to slide ${i+1}`);
    b.addEventListener('click', () => this.go(i), {signal}); this.dots.append(b);
   });
   this.prev.addEventListener('click', () => this.go(this.index()-1), {signal});
   this.next.addEventListener('click', () => this.go(this.index()+1), {signal});
   this.track.addEventListener('scroll', () => this.update(), {signal, passive:true});
   this.addEventListener('shopify:block:select', e => {const i=this.cards.indexOf(e.target.closest('article'));if(i>=0)this.go(i);}, {signal});
   this.observer = new ResizeObserver(() => this.update()); this.observer.observe(this.track);
   this.update();
  }
  index() {const first=this.cards[0], second=this.cards[1]; const step=second?second.offsetLeft-first.offsetLeft:this.track.clientWidth;return Math.round(this.track.scrollLeft/Math.max(1,step));}
  go(i) {const card=this.cards[Math.max(0,Math.min(i,this.cards.length-1))];if(card)this.track.scrollTo({left:card.offsetLeft-this.cards[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
  update() {const max=this.track.scrollWidth-this.track.clientWidth;this.querySelector('.tp26-controls').hidden=max<3;this.prev.disabled=this.track.scrollLeft<2;this.next.disabled=this.track.scrollLeft>=max-2;[...this.dots.children].forEach((d,i)=>d.setAttribute('aria-current',String(i===this.index())));}
  disconnectedCallback() {this.abort?.abort();this.observer?.disconnect();}
 });
}
